import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import DateTimeRow from './DateTimeRow';
import './Modal.css';

function AlertTypeModal({ isOpen, onRequestClose, action, alertType, onClose, error, handleChangedAlertTypeCallback }) {
    const [editAlertType, setEditAlertType] = useState(alertType);


    useEffect(() => {
        Modal.setAppElement('#root');
    }, []); // Empty dependency array to run the effect only once when the component is mounted

    useEffect(() => {
        // Reset internal state when modal opens or alertType prop changes
        // Normalize null values to empty strings so inputs stay controlled
        const normalized = Object.fromEntries(
            Object.entries(alertType).map(([key, val]) => [key, val ?? ''])
        );
        setEditAlertType(normalized);
    }, [alertType, isOpen]);

    return (
        <div>
            {/* Modal for adding or modifiying AlertType */}
            <Modal
                isOpen={isOpen}
                onRequestClose={onRequestClose}
            >

                <h3>Fill in the Alert Destination details to {action === "Add" ? "add:" : "modify"}</h3>

                <h4>{error !== null ? error : null}</h4>

                <label>Alert Type: </label>
                <input
                    type="text"
                    value={editAlertType.alertType}
                    onChange={(e) => setEditAlertType({ ...editAlertType, alertType: e.target.value })}
                />
                <label>Alert Value: </label>
                <input
                    type="text"
                    value={editAlertType.alertValue}
                    onChange={(e) => setEditAlertType({ ...editAlertType, alertValue: e.target.value })}
                />
                <label>Description: </label>
                <input
                    type="text"
                    value={editAlertType.description}
                    onChange={(e) => setEditAlertType({ ...editAlertType, description: e.target.value })}
                />
                <label>Status: </label>
                <input
                    type="text"
                    value={editAlertType.status}
                    onChange={(e) => setEditAlertType({ ...editAlertType, status: e.target.value })}
                />
                <label>TimeStamp: </label>
                <DateTimeRow
                    value={editAlertType.timeStamp}
                    onChange={(val) => setEditAlertType({ ...editAlertType, timeStamp: val })}
                    placeholderText="Select timestamp"
                />

                <div style={{ marginTop: '15px' }}>
                    <button onClick={() => handleChangedAlertTypeCallback(editAlertType, action)}>{action === "Add" ? "Add New Destination" : "Save Destination"}</button>
                    <button className="cancel" onClick={onClose}>Cancel</button>
                </div>
            </Modal>
        </div>
    );
};

export default AlertTypeModal;